import React, { useEffect } from 'react';
import {FaInstagram, FaYoutube} from 'react-icons/fa';
import {FaLinkedin} from 'react-icons/fa';
import {FaFacebook} from 'react-icons/fa';

import AOS from 'aos';
import 'aos/dist/aos.css';

const Intro = () => {


  useEffect(() => {
    AOS.init({duration:1500});
}, [])

  return (
    <div className='pt-10'>
      

      <div className="hero min-h-screen bg2">
  <div className="hero-content flex-col lg:flex-row-reverse">
   
    <img src="images/photoshoot.jpg" className="lg:w-72  shadow-2xl lg:mr-10   hover:animate-pulse" alt='' data-aos="fade-left" />
  
    <div data-aos="fade-right" >
      
      <h1 className="lg:text-6xl sm:text-5xl font-bold font-mono mt-3 text-purple-500"> Capturing Moments Into Memories </h1>
      <p className="py-6 text-gray-300 w-3/4 text-xl"  >Your each movement, your each emotion is nothing but a beautiful picture and I just want to hold on those moments with camera and make it a piece of art with adroit editing
</p>

<div className='flex my-3'>
  
  <a href="https://www.linkedin.com/in/juliana-tonu-65959a195/" target="_blank" className='text-purple-500 text-5xl mr-3  mb-6 hover:scale-105 duration-500 hover:text-pink-300'><FaLinkedin/></a>
  <a href="https://www.instagram.com/_____juliiiiiiiiiiiiiiii_____/" target="_blank" className='text-purple-500 text-5xl mr-3  mb-6 hover:scale-105 duration-500 hover:text-pink-300'><FaInstagram></FaInstagram></a>
  <a href="https://www.facebook.com/juliana.tonu"  target="_blank" className='text-purple-500 text-5xl mr-3  mb-6 hover:scale-105 duration-500 hover:text-pink-300'><FaFacebook/></a>
  <a href="https://github.com/JulianaTonu" target="_blank" className='text-purple-500 text-5xl mr-3  mb-6 hover:scale-105 duration-500 hover:text-pink-300'><FaYoutube/></a>
  
  
  </div>


    
    </div>
  </div>
</div>
    </div>
  )
}
export default Intro;